//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueApexCharts from 'vue-apexcharts'
// eslint-disable-next-line object-curly-newline
import { mdiDotsVertical } from '@mdi/js'

import { getVuetify } from '@core/utils'

export default {
  components: {
    VueApexCharts,
  },
  setup() {
    const $vuetify = getVuetify()

    const chartOptions = {
      colors: [
        $vuetify.theme.currentTheme.primary,
        $vuetify.theme.currentTheme.success,
        $vuetify.theme.currentTheme.warning,
      ],
      chart: {
        type: 'radialBar',
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: '42%',
          },
          track: {
            background: 'transparent',
            margin: 10,
          },
          dataLabels: {
            name: {
              fontSize: '50px',
              offsetY: 35,
            },
            value: {
              fontSize: '2.125rem',
              offsetY: -10,
              formatter(value) {
                return `${value}k`
              },
            },
            total: {
              show: true,
              label: '2021',
              formatter(value) {
                return `${value.globals.seriesTotals.reduce((total, num) => total + num)}k`
              },
            },
          },
        },
      },
      labels: ['Electronics', 'Clothing', 'Computers'],
      grid: {
        padding: {
          top: -10,
          left: -50,
          right: -50,
        },
      },
      stroke: {
        lineCap: 'round',
      },
    }

    const chartData = [71, 78, 86]

    return {
      chartOptions,
      chartData,

      icons: {
        mdiDotsVertical,
      },
    }
  },
}
